import { COLOR1 } from '../../constants';

export const LoaderStyles = {
  backdrop: {
    zIndex: 1301,
    backgroundColor: 'rgba(233, 233, 235, 0.60)',
  },

  center_style: {
    display: 'flex',
    justifyContent: 'center',
  },

  loading: {
    font: 'normal normal bold 30px/34px Arial',
    letterSpacing: '0.21px',
    color: COLOR1,
    opacity: 1,
    marginTop: '4px',
    paddingLeft: '32px',
    '@media (max-width:600px)': {
      font: 'normal normal bold 22px/34px Arial',
      paddingLeft: '22px',
    },
  },

  loaderStyle: {
    width: '114px',
    '@media (max-width:600px)': {
      width: '90px',
    },
  },

  loader_circle: {
    width: '105px',
    '@media (max-width:600px)': {
      width: '90px',
    },
  },
};
